import { render, staticRenderFns } from "./MultipleSelector.vue?vue&type=template&id=2810aa15&scoped=true"
import script from "./MultipleSelector.vue?vue&type=script&lang=js"
export * from "./MultipleSelector.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelector.vue?vue&type=style&index=0&id=2810aa15&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2810aa15",
  null
  
)

export default component.exports